module.exports = __webpack_public_path__ + "static/media/dawn.c476f898.png";